var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-chip',{attrs:{"message":_vm.fileAddButtonMessage,"icon":"mdi-plus","hideRemove":""},on:{"click":_vm.addFiles}})}
var staticRenderFns = []

export { render, staticRenderFns }